<template>
	<div class="card" :class="{dark,standout,large}">
		<div class="card-body" :class="{stacked}">
			<label>{{label}}</label>
			<span class="value">{{value}}</span>
			<span v-if="secondaryValue" class="value">{{secondaryValue}}</span>
		</div>
	</div>
</template>

<script type="text/javascript">
export default {
	name: "InfoBox",
	props: [
		"label", //string
		"value", //string, number
		"secondaryValue",
		"stacked", //if true, label will appear above value, centered
		"dark",
		"standout",
		"large"
	]
}
</script>

<style type="text/css" scoped>
	.card {
		margin: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.card.large {
		height: 100%;
		min-height: 0;
	}

	.card .card-body {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-top: 0;
	}

	.card .card-body.stacked {
		flex-direction: column;
	}

	.card.standout {
		border: 3px solid var(--button-secondary);
	}

	.card.dark {
		background-color: var(--button-secondary-faded);
	}

	.card.standout .card-body {
		padding: 10px;
		padding-bottom: 11px;
		padding-left: 15px;
		padding-right: 15px;
	}

	.card-body {
		padding: 0px;
		padding-bottom: 1px;
		padding-left: 10px;
		padding-right: 10px;
		text-align: center;
	}

	.card-body.stacked {
		text-align: center;
	}

	.stacked label {
		display: block;
	}

	.large label {
		font-size: 13pt;
	}

	label {
		padding: 0;
		margin: 0;
		margin-right: 5px;
		font-size: 11pt;
		text-transform: uppercase;
	}

	.large span.value {
		font-size: 18pt;
	}

	span.value {
		font-weight: bold;
		font-size: 14pt;
	}
</style>